"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.END_OF_YEAR_CHECKLIST_SEASON = void 0;
exports.END_OF_YEAR_CHECKLIST_SEASON = { year: 2026, givingTuesdayDate: "2026-12-01" };
